<template>
  <div>
    <router-link
      :to="{ name: 'Member', params: { homeId: home.homeId } }"
      active-class="active"
      tag="div"
      v-for="home in homes"
      :key="home.homeId"
      class="member-item d-flex px-3 py-3"
    >
      <div class="flex-grow-1 flex-shrink-0">
        <div class="house-number-label mb-1">
          {{ $t("feature.member.house_number") }}
        </div>
        <h5 class="house-number">{{ home.addressNo }}</h5>
      </div>
      <div class="flex-grow-0 flex-shrink-0 ml-1">
        <div class="member-status" :class="{ active: home.isActive }">
          <div class="label mb-1">{{ $t("feature.member.status") }}</div>
          <div class="info">
            {{
              home.isActive
                ? $t("feature.member.active")
                : $t("feature.member.in_active")
            }}
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    homes: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.member-item {
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
  .house-number-label {
    font-size: 11px;
    color: #8c8786;
  }
  h5.house-number {
    color: black;
    font-size: 22px;
    font-weight: bold;
  }
  .member-status {
    border-radius: 5px;
    background-color: #f9f9f9;
    padding: 8px;
    .label {
      font-size: 11px;
    }
    .info {
      font-weight: bold;
      font-size: 14px;
      color: #8c8786;
    }
    &.active {
      .info {
        color: #00b793;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/member/HomeNavigation.vue